import { createSlice } from "@reduxjs/toolkit";
import {
  editStaffBuilder,
  fetchStaffBuilder,
  signUpStaffBuilder,
} from "./builder";

const initialState = {
  staff: {
    data: [],
    perPage: null,
    total: 0,
  },
  signUpStaffPending: false,
  fetchStaffPending: false,
  editStaffPending: false,
};

export const staffSlice = createSlice({
  name: "staffInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    signUpStaffBuilder(builder);
    fetchStaffBuilder(builder);
    editStaffBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

// export const {} = userSlice.actions;

export const selectStaff = (state) => state.staffInfo.staff;
export const selectSignUpStaffPending = (state) =>
  state.staffInfo.signUpStaffPending;
export const selectEditStaffPending = (state) =>
  state.staffInfo.editStaffPending;

export default staffSlice.reducer;
